import ContentfulService from '@/services/ContentfulService'

import {
  ContentfulProductMeta,
  ContentfulBlockExpertsFields,
  ContentfulExpertPage,
  ContentfulBlockExpertItem,
} from '@/types'

export const getProductCrumbs = <T extends ContentfulProductMeta>(cProduct: T) => {
  const typePageSlugsHierarchy = [
    cProduct.fields.types?.[0]?.fields?.slug,
    cProduct.fields.subtypes?.[0]?.fields?.slug,
    cProduct.fields.subtypesLevel2?.[0]?.fields?.slug,
  ].filter((el) => el)
  const typePagesHierarchy = typePageSlugsHierarchy
    .map((pageSlug) => ContentfulService.service.getPageBySlug(pageSlug))
    .filter((el) => el)
  const deepestAvailableTypePage = typePagesHierarchy[typePagesHierarchy.length - 1]
  return deepestAvailableTypePage
    ? deepestAvailableTypePage.crumbs.map((el) => ({
        name: el.fields.title,
        link: el.fields.slug,
      }))
    : []
}

export const transformExperts = (fields: ContentfulBlockExpertsFields) => {
  const cards =
    fields?.experts
      ?.filter((entry) => entry.fields)
      .map((entry) => {
        const isExpertPageCheck = (
          el: ContentfulExpertPage | ContentfulBlockExpertItem,
        ): el is ContentfulExpertPage => el && 'slug' in el.fields && 'name' in el.fields
        const isExpertPage = isExpertPageCheck(entry)
        const link = isExpertPage
          ? ContentfulService.service.transformSlugToLink(`experts/${entry.fields.slug}`)
          : ''
        return {
          link,
          custonActionButton:
            isExpertPage && entry.fields.carouselCustomButton
              ? entry.fields.carouselCustomButton?.fields
              : '',
          actionButtonLink: `${link}#entrySection`,
          image:
            isExpertPage && entry.fields.expertImage
              ? ContentfulService.service.getImageUrl(entry.fields.expertImage)
              : ContentfulService.service.getProductDefaultImage(),
          title: isExpertPage ? entry.fields.name : '',
          subtitle: entry.fields.subtitle,
          buttonId: 'buttonId',
        }
      }) || []
  return {
    title: fields.title,
    subtitle: fields.paragraph,
    cards,
    type: 'experts',
  }
}
